module.exports = __webpack_public_path__ + "static/img/card.cd71a854.jpg";